/**
 * Runs `run` unless a run is already in flight in `slot`, in which case the caller joins it.
 *
 * Why this exists: the conversation is created on the server when the panel opens, which takes
 * about a second on a cold Lambda. A chip clicked in that window used to call `start()` again,
 * find one already running, and RETURN — and `send` then saw no conversation and quietly dropped
 * the visitor's question. Nothing happened, nothing was logged. Joining the in-flight run makes
 * the click wait for the conversation instead.
 */
export function joinInFlight<T>(slot: { current: Promise<T> | null }, run: () => Promise<T>): Promise<T> {
  if (!slot.current) {
    // Cleared on success AND failure, so one failed start does not wedge every later attempt.
    slot.current = run().finally(() => {
      slot.current = null;
    });
  }
  return slot.current;
}
